const sizes = {
  small: ["20x30", "30x40", "40x50"],
  big: ["50x60", "60x50"],
};

const raw = [
  [100, sizes.small, 43],
  [100, sizes.big, 45],
  [200, sizes.small, 25],
  [200, sizes.big, 27],
  [300, sizes.small, 22],
  [300, sizes.big, 22],
  [400, sizes.small, 16],
  [400, sizes.big, 18],
  [500, sizes.small, 14],
  [500, sizes.big, 16],
  [1000, sizes.small, 11],
  [1000, sizes.big, 12],
  [2000, sizes.small, 9],
  [2000, sizes.big, 10],
];

const data = raw
  .sort(([a], [b]) => b - a)
  .map(([prints, sizes, price]) => ({ prints, sizes, price }));

export function printPrice(size, prints) {
  return data.find(
    (row) => row.prints < prints && row.sizes.includes(size)
  )?.price;
}
